import { useEffect, useState } from 'react';

// graphql
import { PageInfo, useTerminalLossTransfersQuery, useTerminalProfitWithdrawalsQuery } from '@/generated/graphql';

// material ui
import { Grid } from '@mui/material';

// interfaces
import {
  ITerminalProfitWithdrawalQueryVariable,
  ITerminalProfitWithdrawalTable,
  mapGQLTerminalProfitWithdrawal,
  ITerminalLossTransferTable,
  ITerminalLossTransferQueryVariable,
  mapGQLTerminalLossTransfer,
} from '@/shared/interfaces';

interface IProps {
  refetchTerminalProfitLossQuery: boolean;
  setRefetchTerminalProfitLossQuery: React.Dispatch<React.SetStateAction<boolean>>;
}

// components
import { TableTerminalProfitWithdrawals } from './terminal-profit-withdrawal-table';
import { TableTerminalLossTransfers } from './terminal-loss-transfer-table';

export const TerminalProfitLoss = ({ refetchTerminalProfitLossQuery, setRefetchTerminalProfitLossQuery }: IProps) => {
  const [terminalProfitWithdrawals, setTerminalProfitWithdrawals] = useState<ITerminalProfitWithdrawalTable[]>([]);
  const [terminalLossTransfers, setTerminalLossTransfers] = useState<ITerminalLossTransferTable[]>([]);

  const [terminalProfitWithdrawalsQueryVariable, setTerminalProfitWithdrawalsQueryVariable] =
    useState<ITerminalProfitWithdrawalQueryVariable>({
      first: 25,
    });

  const [terminalLossTransfersQueryVariable, setTerminalLossTransfersQueryVariable] = useState<ITerminalLossTransferQueryVariable>({
    first: 25,
  });

  const [terminalProfitWithdrawalsPageInfo, setTerminalProfitWithdrawalsPageInfo] = useState<PageInfo>();
  const [terminalProfitWithdrawalsTotalCount, setTerminalProfitWithdrawalsTotalCount] = useState<number>(0);
  const [terminalLossTransfersPageInfo, setTerminalLossTransfersPageInfo] = useState<PageInfo>();
  const [terminalLossTransfersTotalCount, setTerminalLossTransfersTotalCount] = useState<number>(0);

  const terminalProfitWithdrawalsQuery = useTerminalProfitWithdrawalsQuery({
    variables: terminalProfitWithdrawalsQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const mappedData = data.terminalProfitWithdrawals.nodes.map((x) => mapGQLTerminalProfitWithdrawal(x));

      const mappedTableData: ITerminalProfitWithdrawalTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        status: x.status,
        cashierUsername: x.cashier.user.username,
        adminUsername: x.admin.user.username,
        createdAt: x.createdAt,
      }));

      setTimeout(() => {
        setTerminalProfitWithdrawals(mappedTableData);
        setTerminalProfitWithdrawalsPageInfo(data.terminalProfitWithdrawals.pageInfo);
        setTerminalProfitWithdrawalsTotalCount(data.terminalProfitWithdrawals.totalCount);
      }, 100);
    },
  });

  const terminalLossTransfersQuery = useTerminalLossTransfersQuery({
    variables: terminalLossTransfersQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const mappedData = data.terminalLossTransfers.nodes.map((x) => mapGQLTerminalLossTransfer(x));

      const mappedTableData: ITerminalLossTransferTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        status: x.status,
        cashierUsername: x.cashier.user.username,
        adminUsername: x.admin.user.username,
        createdAt: x.createdAt,
      }));

      setTimeout(() => {
        setTerminalLossTransfers(mappedTableData);
        setTerminalLossTransfersPageInfo(data.terminalLossTransfers.pageInfo);
        setTerminalLossTransfersTotalCount(data.terminalLossTransfers.totalCount);
      }, 100);
    },
  });

  useEffect(() => {
    if (refetchTerminalProfitLossQuery === true) {
      console.log('REFETCH');
      setRefetchTerminalProfitLossQuery(false);
      terminalProfitWithdrawalsQuery.refetch();
      terminalLossTransfersQuery.refetch();
    }
  }, [refetchTerminalProfitLossQuery]);

  return (
    <>
      <Grid container spacing={2} px={2}>
        <Grid size={6}>
          <TableTerminalProfitWithdrawals
            rows={terminalProfitWithdrawals}
            setTerminalProfitWithdrawalQueryVariable={setTerminalProfitWithdrawalsQueryVariable}
            terminalProfitWithdrawalQueryVariable={terminalProfitWithdrawalsQueryVariable}
            totalCount={terminalProfitWithdrawalsTotalCount}
            pageInfo={terminalProfitWithdrawalsPageInfo}
            getTerminalProfitWithdrawalLoading={terminalProfitWithdrawalsQuery.loading}
          />
        </Grid>
        <Grid size={6}>
          <TableTerminalLossTransfers
            rows={terminalLossTransfers}
            setTerminalLossTransferQueryVariable={setTerminalLossTransfersQueryVariable}
            terminalLossTransferQueryVariable={terminalLossTransfersQueryVariable}
            totalCount={terminalLossTransfersTotalCount}
            pageInfo={terminalLossTransfersPageInfo}
            getTerminalLossTransferLoading={terminalLossTransfersQuery.loading}
          />
        </Grid>
      </Grid>
    </>
  );
};
